// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1MHCj","name":"ConsentHeader_name__3grjr","birthday":"ConsentHeader_birthday__2wAXG","skeleton":"ConsentHeader_skeleton__37YKR"};